import { Button, Dialog, DialogTitle, Link, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import BrandInterfaceTable from "./BrandInterfaceTable";

interface Props {
  open: boolean;
  handleClose: () => void;
  title: string;
  brands: { brand_id: number | string; brand_name: string }[];
  brandsCount: number;
  subtitleSuffix: string;
  onViewActiveBrands?: () => void;
}

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
};

const BrandInterfaceModal = ({
  open,
  handleClose,
  title,
  brands,
  brandsCount,
  subtitleSuffix,
  onViewActiveBrands,
}: Props) => {
  return (
    <>
      <Dialog
        open={open}
        PaperProps={{ sx: { width: "450px", maxWidth: "450px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 10px 0px" }}>
            {title}
          </DialogTitle>
          <Typography variant="body2">
            {onViewActiveBrands && brandsCount > 0 ? (
              <Link
                component="button"
                underline="always"
                color="secondary"
                onClick={onViewActiveBrands}
              >
                {brandsCount}
              </Link>
            ) : (
              brandsCount
            )}{" "}
            {subtitleSuffix}
          </Typography>

          <BrandInterfaceTable tableHeadings={tableHeadings} rows={brands} />

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button variant="contained" color="secondary" onClick={handleClose}>
              Close
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default BrandInterfaceModal;
